import { companyContextService } from '@/services/CompanyContextService';
import { handleUnauthorized, registerAuth } from '@/unauthorizedResponse';
(function () {
  const _apiCheck = null;
  angular.module('leanlaw').config(['$httpProvider', function ($httpProvider) {
    // Registered ahead of angular-loading-bar: response interceptors run in reverse,
    // so the bar must see a response before responseError swallows it into a
    // never-settling promise, or its request count never balances and it stays up.
    $httpProvider.interceptors.unshift('versionAndAuthInterceptor');
  }])
  //// Disabling this because it keeps inadvertently keeps the session open
  //// so that it never times out.
  //.run(['$interval', 'leanLawApi', function ($interval, leanLawApi) {
  //    // Ping API every 10 minutes to see if we need to refresh
  //    _apiCheck = $interval(function () {
  //        console.log('ping');
  //        leanLawApi.getMe();
  //    }, 10 * 60 * 1000);
  //}])
  .value('currentAccountId', {
    value: null
  }).factory('versionAndAuthInterceptor', ['version', '$q', '$window', '$interval', 'leanLawAuth', 'currentAccountId', function (version, $q, $window, $interval, leanLawAuth, currentAccountId) {
    registerAuth(leanLawAuth);
    let _countdown;
    return {
      request(config) {
        const pageCompanyId = companyContextService.getPageLoadCompanyId();
        if (window.leanlaw.token && !config.headers.Authorization) {
          config.headers = config.headers || {};
          config.headers['x-leanlaw-accountId'] = currentAccountId.value;
          config.headers['x-leanlaw-version'] = 'v1';
          config.headers['x-leanlaw-source'] = window.leanlaw.source;
          config.headers.Authorization = `Bearer ${window.leanlaw.token}`;
          if (pageCompanyId) {
            config.headers['x-leanlaw-companyid'] = pageCompanyId;
          }
          return config;
        }

        // return leanLawAuth.authenticate().then(function (auth) {
        //   if (auth && auth.token && !config.headers.Authorization) {
        //     config.headers = config.headers || {};
        //     config.headers.Authorization = 'Bearer ' + auth.token;
        //   }
        //   return config;
        // });
        if (currentAccountId.value) {
          config.headers = config.headers || {};
          config.headers['x-leanlaw-accountId'] = currentAccountId.value;
          config.headers['x-leanlaw-version'] = 'v1';
          config.headers['x-leanlaw-source'] = window.leanlaw.source;
          if (pageCompanyId) {
            config.headers['x-leanlaw-companyid'] = pageCompanyId;
          }
        }
        return config;
      },
      requestError(config) {
        return config;
      },
      response(res) {
        var url = res.config.url?.toString() || '';
        if (url.indexOf('/health') > 0) {
          // bypass check if we are doing the initial auth check
          return res;
        }

        // // Check to see if API version was updated
        // var apiVersion = res.headers('x-leanlaw-version');
        // var pieces = version.split('.');
        // if (!apiVersion || pieces.length < 2 || _countdown) {
        //   return res;
        // }
        // if (apiVersion.indexOf(pieces[0] + '.' + pieces[1]) != 0) {
        //   console.log('API and Javascript version mismatch: ', apiVersion, version);
        //   countDownAlert("The LeanLaw software was updated and it requires us to reload the page").then(function () {
        //     $window.location.reload();
        //   });
        // }
        return res;
      },
      responseError(res) {
        var url = res.config.url?.toString() || '';
        var isAuthCheck = Boolean(res.config) && url.indexOf('/health') > 0;
        if (res.status === 401) {
          return $q.when(handleUnauthorized(res.data, {
            isAuthCheck,
            auth: leanLawAuth
          })).then(handled => {
            if (handled) return $q.defer().promise;
            return isAuthCheck ? res : $q.reject(res);
          });
        }
        if (isAuthCheck) {
          // bypass check if we are doing the initial auth check
          return res;
        }

        // A cancelled/aborted request (e.g. via $http config.timeout, or the
        // browser navigating away) comes back with status -1. This was not a
        // real failure, so don't propagate it to downstream .catch() handlers
        // (which would otherwise show a spurious "An error occurred" toast).
        if (res.status === -1) {
          return $q.defer().promise;
        }

        // Handle company context mismatch (409 Conflict)
        if (res.status === 409) {
          var data = res.data;
          if (data && data.error === 'COMPANY_CONTEXT_MISMATCH') {
            // Dispatch the same event the axios interceptor uses, so the
            // globally-mounted CompanyContextMismatchModal (companyContextModal.js)
            // handles it — consistent UX across Angular and Vue pages.
            window.dispatchEvent(new CustomEvent('companyContextMismatch', {
              detail: {
                message: data.message,
                pageCompanyId: res.config?.headers?.['x-leanlaw-companyid'],
                requestUrl: res.config?.url
              }
            }));
            // Return a never-resolving promise so the error does NOT propagate
            // to downstream .catch() handlers (which would show a duplicate toast).
            return $q.defer().promise;
          }
        }
        return $q.reject(res);
      }
    };
    function countDownAlert(message) {
      const d = $q.defer();
      let seconds = 10;
      _countdown = $interval(() => {
        seconds -= 1;
        if (seconds == 0) {
          d.resolve();
        }
        $('#ll-seconds').html(seconds);
      }, 1000, seconds);
      bootbox.confirm(`<h1 style="float:left;margin-right:10px;"><span class="fa fa-refresh"></span></h1><h4>${message}</h4> <p>Reloading automatically in <b id="ll-seconds">${seconds}</b> seconds (or click OK to reload now)...`, ok => {
        if (ok) {
          d.resolve();
        } else {
          $interval.cancel(_countdown);
          d.reject();
        }
      });
      return d.promise;
    }
  }]);
})();